<template>
	<v-container fluid>
		<v-container>
			<v-row>
				<v-col>
					<h1>Storico Vendite</h1>
				</v-col>
				<v-col cols="12" sm="3" md="2" xl="1" style="display: flex; flex-direction: row; justify-content: flex-end;">
					<v-btn
						color="primary"
						@click="downloadReport"
						:disabled="getFiltriStoricoVendite.kind != 'Smartphone Usato Art.36'"
						>Scarica XLS</v-btn
					>
				</v-col>
			</v-row>

			<v-row>
				<v-col>
					<stats :stats="stats" />
				</v-col>
			</v-row>

			<v-row>
				<v-col cols="12" xl="9" class="order-last order-xl-first">
					<Table :operations="filteredOperations" v-on:fetch="fetchOperations" />
				</v-col>
				<v-col>
					<Filters :operations="filteredOperations" />
				</v-col>
			</v-row>
		</v-container>
	</v-container>
</template>

<script>
import axios from 'axios'
import Fuse from 'fuse.js'

import { mapGetters } from 'vuex'

import Filters from './../components/storico-vendite/Filters'
import Table from './../components/storico-vendite/Table'
import Stats from './../components/storico-vendite/Stats'
import AreaChart from './../components/storico-vendite/AreaChart.js'

export default {
	name: 'StoricoVendite',
	components: {
		Filters,
		Table,
		Stats,
		AreaChart,
	},

	data() {
		return {
			operations: [],
			config: {
				headers: {
					Authorization: `Bearer ${localStorage.getItem('access_token')}`,
				},
			},
		}
	},

	computed: {
		...mapGetters(['getFiltriStoricoVendite']),
		filteredOperations() {
			const options = {
				includeScore: true,
				minMatchCharLength: 2,
				findAllMatches: true,
				minMatchCharLength: 3,
				location: 0,
				distance: 100,
				threshold: 0.4,

				keys: [
					'kind',
					'payment_method',
					'user',
					'article.brand',
					'article.color',
					'article.desctiption',
					'article.disk_space',
					'article.ean',
					'article.grade',
					'article.name',
					'article.model',
					'article.ram',
					'article.serial',
					'article.serial_number',
					'article.surename',
				],
			}

			let filtered = this.operations

			if (this.getFiltriStoricoVendite.kind !== 'Tutte') {
				filtered = filtered.filter((el) => el.kind === this.getFiltriStoricoVendite.kind)
			}

			if (this.getFiltriStoricoVendite.payment !== 'Tutti') {
				filtered = filtered.filter((el) => el.payment_method === this.getFiltriStoricoVendite.payment)
			}

			if (this.getFiltriStoricoVendite.user !== 'Tutti') {
				filtered = filtered.filter((el) => el.user === this.getFiltriStoricoVendite.user)
			}

			if (this.getFiltriStoricoVendite.invoice === true) {
				filtered = filtered.filter((el) => el.invoice === 1)
			} else if (this.getFiltriStoricoVendite.invoice === false) {
				filtered = filtered.filter((el) => el.invoice === 0)
			}

			if (this.getFiltriStoricoVendite.b2b === true) {
				filtered = filtered.filter((el) => el.b2b === 1)
			} else if (this.getFiltriStoricoVendite.b2b === false) {
				filtered = filtered.filter((el) => el.b2b === 0)
			}

			if (this.getFiltriStoricoVendite.gift === true) {
				filtered = filtered.filter((el) => el.gift === 1)
			} else if (this.getFiltriStoricoVendite.gift === false) {
				filtered = filtered.filter((el) => el.gift === 0)
			}

			if (this.getFiltriStoricoVendite.coffee === true) {
				filtered = filtered.filter((el) => el.coffee === 1)
			} else if (this.getFiltriStoricoVendite.coffee === false) {
				filtered = filtered.filter((el) => el.coffee === 0)
			}

			if (this.getFiltriStoricoVendite.points_sh === true) {
				filtered = filtered.filter((el) => el.points_sh === 1)
			} else if (this.getFiltriStoricoVendite.points_sh === false) {
				filtered = filtered.filter((el) => el.points_sh === 0)
			}

			if (typeof this.getFiltriStoricoVendite.search === 'string' && this.getFiltriStoricoVendite.search.length > 0) {
				let index = Fuse.createIndex(options.keys, filtered)

				const fuse = new Fuse(filtered, options, index)

				const result = fuse.search(this.getFiltriStoricoVendite.search)

				console.log('fuse', result)

				filtered = result.map((el) => el.item)
			}

			return filtered
		},

		stats() {
			if (this.filteredOperations.length > 0) {
				const incassato = this.filteredOperations
					.map((el) => el.price)
					.reduce((accumulator, currentValue) => parseFloat(accumulator) + parseFloat(currentValue))
					.toFixed(2)
				const utile = this.filteredOperations
					.map((el) => el.gain)
					.reduce((accumulator, currentValue) => parseFloat(accumulator) + parseFloat(currentValue))
					.toFixed(2)
				const iva = this.filteredOperations
					.map((el) => el.vat)
					.reduce((accumulator, currentValue) => parseFloat(accumulator) + parseFloat(currentValue))
					.toFixed(2)
				const margine = ((utile * 100) / parseFloat(incassato)).toFixed(2)
				const omaggi = this.filteredOperations
					.map((el) => el.gift)
					.reduce((accumulator, currentValue) => parseFloat(accumulator) + parseFloat(currentValue))
				const fatture = this.filteredOperations
					.map((el) => el.invoice)
					.reduce((accumulator, currentValue) => parseFloat(accumulator) + parseFloat(currentValue))
				const caffe = this.filteredOperations
					.map((el) => el.coffee)
					.reduce((accumulator, currentValue) => parseFloat(accumulator) + parseFloat(currentValue))
				const b2b = this.filteredOperations
					.map((el) => el.b2b)
					.reduce((accumulator, currentValue) => parseFloat(accumulator) + parseFloat(currentValue))
				const puntiSh = this.filteredOperations
					.map((el) => el.points_sh)
					.reduce((accumulator, currentValue) => parseFloat(accumulator) + parseFloat(currentValue))

				return [
					{
						title: 'Incassato',
						count: incassato + '€',
					},
					{
						title: 'Utile',
						count: utile + '€',
					},
					{
						title: 'Iva',
						count: iva + '€',
					},
					{
						title: 'Margine',
						count: margine + '%',
					},
					{
						title: 'B2B',
						count: b2b,
					},
					{
						title: 'Fatture',
						count: fatture,
					},
					{
						title: 'Omaggi',
						count: omaggi,
					},
					{
						title: 'Punti SH',
						count: puntiSh,
					},
					{
						title: 'Caffè',
						count: caffe,
					},
				]
			}
		},

		chartdata() {
			let date = []
			let incasso = []
			let iva = []
			let utile = []

			let incassoAggregator = 0
			let ivaAggregator = 0
			let utileAggregator = 0

			this.filteredOperations.map((el, index) => {
				if (
					date.find(
						(element) =>
							element !==
							new Date(el.posix * 1000).toLocaleString('it-IT', { day: '2-digit', month: 'short', year: 'numeric' })
					)
				) {
					if (date.length !== 0) {
						incasso.push(incassoAggregator)
						iva.push(ivaAggregator)
						utile.push(utileAggregator)
					}

					date.push(
						new Date(el.posix * 1000).toLocaleString('it-IT', { day: '2-digit', month: 'short', year: 'numeric' })
					)

					incassoAggregator = el.price
					ivaAggregator = el.vat
					utileAggregator = el.gain

					console.log(date)
				} else {
					incassoAggregator += el.price
					ivaAggregator += el.vat
					utileAggregator += el.gain

					if (index === this.filteredOperations.length - 1) {
						incasso.push(incassoAggregator)
						iva.push(ivaAggregator)
						utile.push(utileAggregator)
					}
				}
			})

			return {
				labels: date,
				datasets: [
					{
						label: 'Incasso',
						backgroundColor: 'rgba(0, 0, 255, 0.3)',
						borderdColor: 'lightblue',
						pointBackgroundColor: 'blue',
						borderWidth: 1,
						borderColor: 'blue',
						data: incasso,
					},
					{
						label: 'Iva',
						backgroundColor: 'rgba(255, 0, 0, 0.2)',
						borderdColor: 'pink',
						pointBackgroundColor: 'red',
						borderWidth: 1,
						borderColor: 'red',
						data: iva,
					},
					{
						label: 'Utile',
						backgroundColor: 'rgba(0, 255, 0, 0.2)',
						borderdColor: 'lightgreen',
						pointBackgroundColor: 'green',
						borderWidth: 1,
						borderColor: 'green',
						data: utile,
					},
				],
			}
		},
	},

	methods: {
		async fetchOperations() {
			let { data } = await axios.post(
				`${process.env.VUE_APP_API}/operations/fetch`,
				{ from: this.getFiltriStoricoVendite.from, to: this.getFiltriStoricoVendite.to },
				this.config
			)

			this.operations = data
		},
		async downloadReport() {
			let { data } = await axios.post(
				`${process.env.VUE_APP_API}/downloads/xls`,
				{
					data: this.filteredOperations,
				},
				this.config
			)

			var fileURL = window.URL.createObjectURL(new Blob([data]))
			var fileLink = document.createElement('a')

			const name = `[${this.formatDate(this.getFiltriStoricoVendite.from)}/${this.formatDate(
				this.getFiltriStoricoVendite.to
			)}]report_vendite_${this.getFiltriStoricoVendite.kind
				.toLowerCase()
				.split(' ')
				.join('_')}.xls`

			fileLink.href = fileURL
			fileLink.setAttribute('download', name)
			document.body.appendChild(fileLink)

			fileLink.click()
		},
		formatDate(date) {
			const datetime = new Date(date)

			return `${datetime.getDate()}-${datetime.getMonth() + 1}-${datetime.getFullYear()}`
		},
	},

	watch: {
		getFiltriStoricoVendite: {
			handler() {
				this.fetchOperations()
			},
			deep: true,
		},
	},

	mounted() {
		this.fetchOperations()
	},
}
</script>
